import course, { CourseListParams } from "@/getinfo-api/course";
import { Course as ICourse } from "@/api/models/course";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { CourseProgress as ICourseProgress } from "@/api/models/course-progress";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import api from "@/getinfo-api";

export default {
  namespaced: true,
  state: {
    courses: [] as Array<ICourse>,
    courseCount: 0,
    courseListeners: [] as Array<ICourseListener>,
    courseProgress: [] as Array<ICourseProgress>
  },
  actions: {
    async GET_COURSES(ctx: any, params: CourseListParams) {
      let courseResponse = await course(params);
      ctx.commit("SET_COURSES", courseResponse.data);
    },
    async COURSES_LISTENER_BY_USER_ID(
      ctx: any,
      arg: { courses: Array<ICourse>; userId: string }
    ) {
      await Promise.allSettled(
        arg.courses.map(async course => {
          let listenerResponse = await api.CourseApi.listenerGetActiveByUser(
            course.id,
            arg.userId
          );
          ctx.commit("SET_LISTENERS", listenerResponse.data);
        })
      );
    },
    async COURSES_PROGRESS(ctx: any, courseListeners: Array<ICourseListener>) {
      await Promise.allSettled(
        courseListeners.map(async el => {
          let progressResponse = await api.CourseApi.listenerProgress(
            el.course.id,
            el.id
          );
          ctx.commit("SET_PROGRESS", progressResponse.data);
        })
      );
    }
  },
  mutations: {
    SET_COURSES(state: any, coursesData: ICoursesList) {
      state.courses = coursesData.courses;
      state.courseCount = coursesData.count;
    },
    SET_LISTENERS(state: any, listener: ICourseListener) {
      state.courseListeners.push(listener);
    },
    SET_PROGRESS(state: any, progress: ICourseProgress) {
      state.courseProgress.push(progress);
    },
    CLEAR(state: any) {
      state.courseListeners = [];
      state.courses = [];
      state.courseCount = 0;
      state.courseProgress = [];
    }
  },
  getters: {
    COURSES(state: any): Array<ICourse> {
      return state.courses;
    },
    COURSES_COUNT(state: any): number {
      return state.courseCount;
    },
    PROGRESSES(state: any): Array<ICourseProgress> {
      return state.courseProgress;
    },
    LISTENER_IN_COURSES(state: any): Array<ICourseListener> {
      return state.courseListeners;
    }
  }
};
